<div class="row" *ngIf="availableAddresses && availableAddresses.length > 0">
  <div class="col-sm-12">
    <small>You can select an address from the list below or search for an address in the allocated search bar. </small>
    <br/>
    <ng-container *ngFor="let add of availableAddresses">
      <a (click)="patchAddressField(add)" style="color: #2d8ac7; cursor: pointer">{{ add.fullAddress }}</a><br/>
    </ng-container>
    <br/>
  </div>
</div>
